<section class="verification-video">
  <p>
    {{ clientName }}, <br />
    {{ 'VIDEO_VERIFICATION.INFO' | translate }}
  </p>
  <app-button (clickEvent)="submit()" [disabled]="isDisabled" [label]="'popups.mobile.next' | translate" color="secondary"></app-button>
</section>
